import { z } from "zod";

export enum TipType {
  user = "user",
  account = "account",
}

export enum TipName {
  onboardingTeamSize = "onboarding_team_size",
  onboardingChooseTemplate = "onboarding_choose_template",
  onboardingInvite = "onboarding_invite",
  canvasWalkthrough = "canvas_walkthrough",
  homePageWalkthrough = "home_page_walkthrough",
  walkthroughExploreOrgChart = "walkthrough_explore_org_chart",
  walkthroughInviteMembers = "walkthrough_invite_members",
  walkthroughAddTemplate = "walkthrough_add_template",
  walkthroughAddElement = "walkthrough_add_element",
  walkthroughAddTask = "walkthrough_add_task",
  walkthroughCreateFrame = "walkthrough_create_frame",
  walkthroughDropComment = "walkthrough_drop_comment",
  walkthroughUploadImage = "walkthrough_upload_image",
  walkthroughPresentationMode = "walkthrough_presentation_mode",
  walkthroughExportCanvas = "walkthrough_export_canvas",
  walkthroughHomePageSections = "walkthrough_home_page_sections",
  walkthroughTeamsAndProjects = "walkthrough_teams_and_projects",
  walkthroughInviteToAccount = "walkthrough_invite_to_account",
  walkthroughInviteInShareCanvas = "walkthrough_invite_in_share_canvas",
  downgradeNotice = "downgrade_notice",
  inviteNotification = "invite_notification",
  restrictedUsersNotice = "restricted_users_notice",
  hiddenCursors = "hidden_cursors",
  inviteTeammatesFromActiveCanvas = "invite_teammates_from_active_canvas",
  homePageRefactor = "home_page_refactor",
  cimOnboardingDeviceSelection = "cim_onboarding_device_selection",
  cimOnboardingBasicTools = "cim_onboarding_basic_tools",
  cimOnboardingTemplates = "cim_onboarding_templates",
}

export const tipSchema = z.object({
  id: z.number(),
  name: z.nativeEnum(TipName),
  type: z.nativeEnum(TipType),
});

export type Tip = z.infer<typeof tipSchema>;
